import { DashboardPage } from "../../components/DashboardPage"
//import DashboardImage from "../../assets/home.svg"
import DashboardImage from "../../assets/icons-no-found-data/COLOR/Dashboard 001.svg"
import { useGlobal } from "../../hooks/global";
import Teste from "../../components/teste";

export const Home: React.FC = () => {
    const { theme } = useGlobal()
    return (
        <DashboardPage>
            <div className="home-container" style={{fontFamily: 'Poppins'}}>

{/* <Teste/> */}
                <img height={300} src={DashboardImage} style={{ objectFit: 'contain' }} />
                <h1 className="home-message" style={{ color: theme === 'dark' ? '#FFF' : '#000' , marginTop: '100px'}}>
                    Bem vindo ao painel administrativo da WebCheckin.app
                </h1>
            </div>
        </DashboardPage>
    )
}